// public/loading.htmlは静的ファイルでi18nを使えないため、
// 翻訳済みタイトルとロケールをクエリで渡してタブのタイトルを表示言語に合わせる
export function buildLoadingPageUrl(lang: string, title: string): string {
  const params = new URLSearchParams({ lang, title });
  return `/loading.html?${params.toString()}`;
}
